import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addonCheckbox", "endTime", "form", "hiddenAddonField"]
  static values = {
    baseDuration: Number,
    startAt: String,
    timezone: String
  }

  toggle() {
    this.updateEndTime()
    this.syncHiddenFields()
  }

  updateEndTime() {
    const totalMinutes = this.calculateTotalDuration()
    const startAt = new Date(this.startAtValue)
    const endAt = new Date(startAt.getTime() + totalMinutes * 60 * 1000)

    // Format time in the branch timezone
    const timeStr = endAt.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: this.timezoneValue
    })

    this.endTimeTarget.textContent = " " + timeStr
  }

  syncHiddenFields() {
    if (!this.hasFormTarget) return

    // Remove existing hidden addon fields
    this.hiddenAddonFieldTargets.forEach(field => field.remove())

    // Add hidden fields for checked addons
    this.addonCheckboxTargets.forEach(checkbox => {
      if (checkbox.checked) {
        const hidden = document.createElement("input")
        hidden.type = "hidden"
        hidden.name = "addon_ids[]"
        hidden.value = checkbox.value
        hidden.setAttribute("data-booking-addons-target", "hiddenAddonField")
        hidden.setAttribute("data-addon-id", checkbox.value)
        this.formTarget.appendChild(hidden)
      }
    })
  }

  calculateTotalDuration() {
    let total = this.baseDurationValue
    this.addonCheckboxTargets.forEach(checkbox => {
      if (checkbox.checked) {
        total += parseInt(checkbox.dataset.duration, 10)
      }
    })
    return total
  }
}
